<template>
  <div class="d-flex align-items-center">
    <div>
      <a-progress type="dashboard" :percent="workdayPercentage" />
    </div>
    <div class="ml-4">
      <p class="text-dark font-weight-bold mb-1">
        Running Working Day: {{running}}
      </p>
      <p class="text-gray-5 mb-0">
        Expected Working Day: {{expected}}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NeoWorkingDayWidget',
  props: ['running', 'expected'],
  computed: {
    workdayPercentage() {
      if (this.running && this.expected) {
        return Math.round((this.running / this.expected) * 100)
      }
      return 0
    },
  },
}
</script>
